
//export * from './http.js'
import * as Api from './api'

export default {
  Api
}



// WEBPACK FOOTER //
// ./src/api/index.js